import React, { useEffect, useRef, useState } from 'react'
import { FaMinus, FaPlus } from 'react-icons/fa6'
import { FiArrowLeftCircle, FiArrowRightCircle } from 'react-icons/fi';
import { MdErrorOutline } from 'react-icons/md';

const AssetTabs = ({ days, assets, assetData, setAssetData, index }) => {
    const [activeTab, setActiveTab] = useState(1);
    const [inventoryError, setInventoryError] = useState(false)
    const daysRef = useRef(null)

    const handleAddAsset = (asset) => {
        const updatedAssetData = structuredClone(assetData)
        const updatedAsset = updatedAssetData.package.find((item) => item.asset_id === asset.asset_id)
        if (updatedAsset) {
            let existing = updatedAsset.inventory.find((item) => item.day === activeTab)
            if (existing) {
                const aiq = assets.find((item) => item.id === asset.asset_id)
                if(existing.count + 1 > aiq.inventory){
                    // alert('cannot increase')
                    setInventoryError(true)
                    setTimeout(()=>{
                        setInventoryError(false)
                    },1500)
                    return;

                }
                existing.count += 1
            }
            else {
                updatedAsset.inventory.push({ day: activeTab, count: 1 })
            }
        }
        updatedAssetData.price_id = index
        setAssetData(updatedAssetData)
    }

    const handleRemoveAsset = (asset) => {
        const updatedAssetData = structuredClone(assetData)
        const updatedAsset = updatedAssetData.package.find((item) => item.asset_id === asset.asset_id)
        if (updatedAsset) {
            const existing = updatedAsset.inventory.find((item) => item.day === activeTab)
            if (existing && existing.count > 0) {
                existing.count -= 1
            }
            else {
                updatedAsset.inventory.push({ day: activeTab, count: 1 })
            }
        }
        setAssetData(updatedAssetData)
    }

    const handleScroll = (direction) => {
        if (direction === 'left') {
            daysRef.current.scrollBy({
                left: -150,
                behavior: 'smooth'
            });
        } else {
            daysRef.current.scrollBy({
                left: 150,
                behavior: 'smooth'
            });
        }
    }
    return (
        <div>
            {inventoryError && <div className='text-red-500 flex items-center gap-1 text-[14px]'>
                <MdErrorOutline size={16} className='text-red-500' />
                Inventory limit for the asset reached for the day.</div>}
                <div className='flex items-center gap-4 border-b-[1px] border-gray-400'>
                <FiArrowLeftCircle onClick={()=>{handleScroll('left')}} size={20} className='text-[#045540] mt-2 shrink-0' />
  
            <div ref={daysRef} style={{scrollbarWidth: 'none'}} class="text-sm max-w-[24rem] overflow-x-auto overflow-y-hidden mt-4 font-medium text-center ">
                <ul class="flex justify-between items-center gap-4">
                    {
                        Array.from({ length: days }).map((_, i) => (
                            <li onClick={() => { setActiveTab(i+1) }}  className={`me-2 pb-2 min-w-[65px] ${activeTab == i + 1 ? 'border-b-2 border-black' : ''}`} key={i}>
                                <span class="p-4 rounded-t-lg">Day {i + 1}</span>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <FiArrowRightCircle onClick={()=>{handleScroll('right')}} size={20} className='text-[#045540] mt-2 shrink-0' />
            </div>
            <div>
                {
                    assetData.package.map((asset, i) => (
                        <div className='flex justify-between items-center my-2 p-2' key={i}>
                            <span>{asset.asset_name}</span>
                            <div className='flex items-center gap-4'>
                                <button onClick={() => { handleRemoveAsset(asset) }} type='button' className='w-5 h-5 text-white flex justify-center items-center bg-[#045540] rounded-md'>
                                    <FaMinus size={12} />
                                </button>
                                <span>{asset.inventory.find((o)=>o.day == activeTab)?.count || 0}</span>
                                <button onClick={() => { handleAddAsset(asset) }} type='button' className='w-5 h-5 text-white flex justify-center items-center bg-[#045540] rounded-md'>
                                    <FaPlus size={12} />
                                </button>
                            </div>
                        </div>
                    ))
                }
            </div>

        </div>
    )
}

export default AssetTabs